module.exports = __webpack_public_path__ + "static/media/team-rocket-6.a1474887.wav";